
import { trpc } from '@tencent/tpro_rmonitor_manage_server_filter_rule';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';


export type IGetConfigReq = WithTypeCast<trpc.rmonitor.manage_server.IGetConfigReq>;
export type IGetConfigRsp = WithTypeCast<trpc.rmonitor.manage_server.IGetConfigRsp>;
export type IAddFilterRuleReq = WithTypeCast<trpc.rmonitor.manage_server.IAddFilterRuleReq>;
export type IAddFilterRuleRsp = WithTypeCast<trpc.rmonitor.manage_server.IAddFilterRuleRsp>;
export type IDeleteFilterRuleReq = WithTypeCast<trpc.rmonitor.manage_server.IDeleteFilterRuleReq>;
export type IDeleteFilterRuleRsp = WithTypeCast<trpc.rmonitor.manage_server.IDeleteFilterRuleRsp>;
export type IGetFilterRulesReq = WithTypeCast<trpc.rmonitor.manage_server.IGetFilterRulesReq>;
export type IGetFilterRulesRsp = WithTypeCast<trpc.rmonitor.manage_server.IGetFilterRulesRsp>;
export type IFilterRule =WithTypeCast<trpc.rmonitor.manage_server.GetFilterRulesRsp.IFilterRule>;
export type IGetFilterRuleHistoryReq =WithTypeCast<trpc.rmonitor.manage_server.IGetFilterRuleHistoryReq>;
export type IGetFilterRuleHistoryRsp =WithTypeCast<trpc.rmonitor.manage_server.IGetFilterRuleHistoryRsp>;
export type IFilterRuleOperation =WithTypeCast<trpc.rmonitor.manage_server
  .GetFilterRuleHistoryRsp.IFilterRuleOperation>;
export type ILabel = WithTypeCast<trpc.rmonitor.manage_server.GetConfigRsp.ILabel>;

export class FilterRuleService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.FilterRuleService,
    });
  }

  /**
   * 获取配置
   */
  public async getConfig(req: IGetConfigReq): Promise<IGetConfigRsp> {
    try {
      return await this.trpcPost<IGetConfigRsp>('GetConfig', req);
    } catch (e) {
      return {};
    }
  }

  public async addFilterRule(req: IAddFilterRuleReq): Promise<boolean> {
    try {
      const rsp = await this.trpcPost<IAddFilterRuleRsp>('AddFilterRule', req);
      return rsp?.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  public async deleteFilterRule(req: IDeleteFilterRuleReq): Promise<boolean> {
    try {
      const rsp =  await this.trpcPost<IDeleteFilterRuleRsp>('DeleteFilterRule', req);
      return rsp?.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  public async getFilterRules(req: IGetFilterRulesReq): Promise<IFilterRule[]> {
    try {
      const rsp =  await this.trpcPost<IGetFilterRulesRsp>('GetFilterRules', req);
      return rsp?.filterRules || [];
    } catch (e) {
      return [];
    }
  }

  public async getFilterRuleHistory(req: IGetFilterRuleHistoryReq): Promise<IFilterRuleOperation[]> {
    try {
      const rsp =  await this.trpcPost<IGetFilterRuleHistoryRsp>('GetFilterRuleHistory', req);
      return rsp?.filterRuleOperations || [];
    } catch (e) {
      return [];
    }
  }
}

export const filterRuleService = new FilterRuleService();
